export const ROUTE_META = [
  { key: "dashboard", path: "/dashboard", label: "Dashboard", icon: "fa-solid fa-gauge", badgeKey: null },
  { key: "etablissements", path: "/etablissements", label: "Établissements", icon: "fa-solid fa-building", badgeKey: "etab" },
  { key: "circuits", path: "/circuits", label: "Circuits", icon: "fa-solid fa-route", badgeKey: null },
  { key: "reservations", path: "/reservations", label: "Réservations", icon: "fa-solid fa-ticket", badgeKey: "resa" },
  { key: "finance", path: "/finance", label: "Finance", icon: "fa-solid fa-wallet", badgeKey: null },
  { key: "academie", path: "/academie", label: "Académie", icon: "fa-solid fa-graduation-cap", badgeKey: null },
  { key: "tickets", path: "/tickets", label: "Tickets Support", icon: "fa-solid fa-life-ring", badgeKey: "tickets" },
];

export default ROUTE_META;
